import React, {useEffect, useState} from "react";
import findByString from "../../Utils/getValueByString";
import {
    useCurrentPosition,
    useWatchPosition
} from "../../../../../Components/JsonScreen/Screen/ScreenComponents/Maps/hooks";
import {MapContainer, Marker, TileLayer, useMapEvent} from "react-leaflet";
import {markerIcon} from "../../../../../Components/JsonScreen/Screen/ScreenComponents/Maps/components/Markers/markerIcon";
import Typography from "@material-ui/core/Typography";
import MapMessage from "../../../../../Components/JsonScreen/Screen/ScreenComponents/Maps/components/MapMessage";

const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: Infinity
};
const LocationType = (props) => {
    const {field, values, globalValues, setValue} = props;
    const [currentLocation, setCurrentLocation] = useState(null);
    const [location, locationError] = useCurrentPosition(options);
    const currentValue = findByString(globalValues, field.path);

    useEffect(() => {
        if (!currentValue) {
            if (location && !locationError) {
                setCurrentLocation([location.coords.latitude, location.coords.longitude]);
                setValue({
                    type: 'point',
                    coordinates: [location.coords.latitude, location.coords.longitude]
                }, field.path)
            }
            return
        }

        setCurrentLocation(currentValue && currentValue.coordinates ? currentValue.coordinates : [0, 0])
    }, [currentValue, location]);

    function handleMapLocation(location) {
        const selectedLocation = {type: "Point", coordinates: location};
        setValue(selectedLocation, field.path);
    }

    if (locationError) {
        return <MapMessage
            type={'error'}
            text={'Geolocation error!'}
        />
    }

    if (!currentLocation) {
        return <MapMessage
            type={'info'}
            text={'Waiting for geolocation data...'}
        />
    }

    return (
        <div style={{width: '100%', height: 250, padding: '3px 0 25px 0px'}}>
            <Typography style={{fontSize: 15}}>{field.label}</Typography>
            <MapContainer
                center={currentLocation}
                zoom={13}
            >
                <TileLayer
                    attribution='&copy; SysbuPro'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {/*<Marker position={currentLocation}/>*/}
                <Markers currentPosition={currentLocation} setPosition={handleMapLocation}/>
            </MapContainer>
        </div>
    )
};
export default LocationType;


const Markers = ({currentPosition, setPosition}) => {
    useMapEvent({
        click(e) {
            setPosition([e.latlng.lat, e.latlng.lng])
        },
    });
    return (
        <Marker position={currentPosition}/>
    )
};